import * as React from 'react';

import { IAddressInfoForDesktopSchema } from '../../repositories/favorites/entities/favorite_entity_for_desktop/AddressInfoForDesktopSchema';

export interface IAddressProps {
  address: IAddressInfoForDesktopSchema[];
}

export function Address({ address }: IAddressProps) {
  return (
    <div className="c-address-line">
      {address.map((addressItem, index) => {
        return (
          <span key={`key_${index}_${addressItem.fullUrl}`}>
            {addressItem.title}
            {index !== address.length - 1 ? ', ' : ''}
          </span>
        );
      })}
    </div>
  );
}
